module.exports = __webpack_public_path__ + "static/media/md.0983e538.svg";